import React from 'react'
import { FaStarHalfAlt, FaStar } from "react-icons/fa";
import { AiOutlineStar } from "react-icons/ai";
import styled from 'styled-components'


function Star({ stars, reviews }) { // 4.7, 58

    const ratingStar = Array.from({ length: 5 }, (elem, index) => { // 0,1,2,3,4
        let numbers = index + 0.5
        // debugger;
        return (
            <span key={index}>
                {
                    stars >= index + 1 ? <FaStar className='icon' /> :
                        stars >= numbers ? <FaStarHalfAlt className='icon' /> :
                            <AiOutlineStar className='icon' />
                }
            </span>
        )
    })

    return (
        <Wrapper>
            <div className="icon-style">
                {ratingStar}
                <p>{reviews} costumer reviews</p>
            </div>
        </Wrapper>
    )
}

const Wrapper = styled.section`
.icon-style {
    display: flex;
    gap: 0.2rem;
    align-items: center;
    justify-content: flex-start;

    .icon {
      font-size: 2rem;
      color: orange;
    }

    .empty-icon {
      font-size: 2.6rem;
    }
    p {
      margin: 0;
      padding-left: 1.2rem;
    }
  }`

export default Star
